import React from 'react'

import { RSSIcon } from 'thewest/routes/static/RSS/components/RSSIcon'
import {
    StyledList,
    StyledListItem,
    StyledLink,
} from 'thewest/routes/static/RSS/components/RSSList/RSSList.styled'

export interface Props {
    items: Array<{
        title: string
        link: string
    }>
}

// type is missing on the typing of React.AnchorHTMLAttributes
const type: object = { type: 'application/rss+xml' }

export const RSSList: React.FC<Props> = ({ items }) => (
    <StyledList>
        {items.map(({ link, title }, index) => (
            <StyledListItem key={index}>
                <StyledLink href={link} rel="alternate" {...type}>
                    <RSSIcon />
                    <h2>{title}</h2>
                </StyledLink>
            </StyledListItem>
        ))}
    </StyledList>
)
